import {yupResolver} from "@hookform/resolvers/yup";

import {useFormRHF, useWatchRHF} from "@pg-design/rhf-components-module";

import {applicationFormValidationSchema} from "../../constants/form/application_form_fields";
import {ApplicationMultiLeadFieldErrors, IApplicationMultiLeadSimpleRecommendationsFormValues} from "./use_application_multi_lead_simple_recommendations";

const USER_DATA_FIELDS = ["name", "email", "phone"] as const;

const USER_DATA_FIELD_MESSAGE_SEPARATORS: Record<(typeof USER_DATA_FIELDS)[number], string> = {name: "\n", email: "\n", phone: ", "};

interface UseApplicationMultiLeadResponsiveFormParams {
    initialValues: IApplicationMultiLeadSimpleRecommendationsFormValues;
    submitApplications: (
        formValues: IApplicationMultiLeadSimpleRecommendationsFormValues,
        handlers: {onFieldErrors: (fieldErrors: ApplicationMultiLeadFieldErrors) => void}
    ) => Promise<void>;
}

export const useApplicationMultiLeadResponsiveForm = (params: UseApplicationMultiLeadResponsiveFormParams) => {
    const {initialValues, submitApplications} = params;

    const formMethods = useFormRHF<IApplicationMultiLeadSimpleRecommendationsFormValues>({
        defaultValues: initialValues,
        resolver: yupResolver(applicationFormValidationSchema, undefined, {raw: true})
    });
    const formValues = useWatchRHF({control: formMethods.control});
    const hasFieldErrors = Object.keys(formMethods.formState.errors).length > 0;
    const isUserDataValid = applicationFormValidationSchema.isValidSync(formValues) && !hasFieldErrors;

    const setServerFieldErrors = (fieldErrors: ApplicationMultiLeadFieldErrors) => {
        USER_DATA_FIELDS.forEach((field) => {
            const fieldError = fieldErrors[field];

            if (fieldError) {
                formMethods.setError(field, {
                    type: "server",
                    message: Array.isArray(fieldError) ? fieldError.join(USER_DATA_FIELD_MESSAGE_SEPARATORS[field]) : fieldError
                });
            }
        });
    };

    const handleValidSubmit = (values: IApplicationMultiLeadSimpleRecommendationsFormValues) =>
        submitApplications(values, {onFieldErrors: setServerFieldErrors});

    return {formMethods, isUserDataValid, handleValidSubmit};
};
import {yupResolver} from "@hookform/resolvers/yup";

import {useFormRHF, useWatchRHF} from "@pg-design/rhf-components-module";

import {applicationFormValidationSchema} from "../../constants/form/application_form_fields";
import {ApplicationMultiLeadFieldErrors, IApplicationMultiLeadSimpleRecommendationsFormValues} from "./use_application_multi_lead_simple_recommendations";

const USER_DATA_FIELDS = ["name", "email", "phone"] as const;

const USER_DATA_FIELD_MESSAGE_SEPARATORS: Record<(typeof USER_DATA_FIELDS)[number], string> = {name: "\n", email: "\n", phone: ", "};

interface UseApplicationMultiLeadResponsiveFormParams {
    initialValues: IApplicationMultiLeadSimpleRecommendationsFormValues;
    submitApplications: (
        formValues: IApplicationMultiLeadSimpleRecommendationsFormValues,
        handlers: {onFieldErrors: (fieldErrors: ApplicationMultiLeadFieldErrors) => void}
    ) => Promise<void>;
}

export const useApplicationMultiLeadResponsiveForm = (params: UseApplicationMultiLeadResponsiveFormParams) => {
    const {initialValues, submitApplications} = params;

    const formMethods = useFormRHF<IApplicationMultiLeadSimpleRecommendationsFormValues>({
        defaultValues: initialValues,
        resolver: yupResolver(applicationFormValidationSchema, undefined, {raw: true})
    });
    const formValues = useWatchRHF({control: formMethods.control});
    const hasFieldErrors = Object.keys(formMethods.formState.errors).length > 0;
    const isUserDataValid = applicationFormValidationSchema.isValidSync(formValues) && !hasFieldErrors;

    const setServerFieldErrors = (fieldErrors: ApplicationMultiLeadFieldErrors) => {
        USER_DATA_FIELDS.forEach((field) => {
            const fieldError = fieldErrors[field];

            if (fieldError) {
                formMethods.setError(field, {
                    type: "server",
                    message: Array.isArray(fieldError) ? fieldError.join(USER_DATA_FIELD_MESSAGE_SEPARATORS[field]) : fieldError
                });
            }
        });
    };

    const handleValidSubmit = (values: IApplicationMultiLeadSimpleRecommendationsFormValues) =>
        submitApplications(values, {onFieldErrors: setServerFieldErrors});

    return {formMethods, isUserDataValid, handleValidSubmit};
};
